/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import { __assign } from '../../_virtual/_tslib.js';
import React__default, { createRef } from 'react';
import Button from '@mui/material/Button/index.js';
import { SnackbarProvider as SnackbarProvider$1, useSnackbar } from '../../node_modules/notistack/notistack.esm.js';

var useSnackbarRef;
var SnackbarUtilsConfigurator = function () {
    useSnackbarRef = useSnackbar();
    return null;
};
var SnackbarProvider = function (_a) {
    var children = _a.children;
    var notistackRef = createRef();
    return (React__default.createElement(SnackbarProvider$1, { maxSnack: 3, ref: notistackRef, action: function (key) { return (React__default.createElement(Button, { color: "inherit", onClick: function () { return notistackRef.current.closeSnackbar(key); } }, "Dismiss")); } },
        React__default.createElement(SnackbarUtilsConfigurator, null),
        children));
};
var toast = {
    success: function (msg, options) {
        this.toast(msg, 'success', options);
    },
    warning: function (msg, options) {
        this.toast(msg, 'warning', options);
    },
    info: function (msg, options) {
        this.toast(msg, 'info', options);
    },
    error: function (msg, options) {
        this.toast(msg, 'error', options);
    },
    toast: function (msg, variant, options) {
        if (variant === void 0) { variant = 'default'; }
        useSnackbarRef.enqueueSnackbar(msg, __assign({ variant: variant }, options));
    },
    close: function (key) {
        useSnackbarRef.closeSnackbar(key);
    },
};
var toast$1 = toast;

export { SnackbarProvider, toast$1 as default };
